import gql from 'graphql-tag';
import eventFragment from '../fragments/event';

const GET_EVENT_BY_ID = gql`
  query getEventById($id: ID!) {
    getEventById(id: $id) {
      ...eventDetails
      type
      eventGroup {
        id
        name
      }
    }
  }
  ${eventFragment.FRAGMENT_EVENT}
`;

const GET_EVENTS_BY_DEVICE_ID = gql`
  query getEventsByDeviceId($deviceId: ID!) {
    getEventsByDeviceId(deviceId: $deviceId) {
      events {
        id
        code
        technicalDescription
        protocol {
          id
          name
        }
        type
        priority
        isMonitorable
        deviceId
        eventGroup {
          id
          name
        }
      }
    }
  }
`;

const GET_ALL_EVENTS_BY_DEVICE_AND_PROTOCOL = gql`
  query getAllEventsByDeviceIdAndProtocolId($deviceId: ID!, $protocolId: ID!) {
    getAllEventsByDeviceIdAndProtocolId(
      deviceId: $deviceId
      protocolId: $protocolId
    ) {
      events {
        id
        code
        technicalDescription
        protocol {
          id
          name
        }
        type
        priority
        isMonitorable
        deviceId
        eventGroup {
          id
          name
        }
      }
    }
  }
`;

const GET_TREINCO_EVENTS = gql`
  query getTreincoEvents($workspaceId: ID!) {
    getTreincoEvents(workspaceId: $workspaceId) {
      events {
        id
        code
        technicalDescription
        protocol {
          id
          name
        }
      }
    }
  }
`;

const GET_EVENTS_BY_IDS = gql`
  query getEventsByIds($eventIds: [ID!]!) {
    getEventsByIds(eventIds: $eventIds) {
      ...eventDetails
      type
      eventGroup {
        id
        name
      }
    }
  }
  ${eventFragment.FRAGMENT_EVENT}
`;

export default {
  GET_EVENTS_BY_DEVICE_ID,
  GET_ALL_EVENTS_BY_DEVICE_AND_PROTOCOL,
  GET_TREINCO_EVENTS,
  GET_EVENT_BY_ID,
  GET_EVENTS_BY_IDS,
};
